import { render } from "./CharacterTraits.vue?vue&type=template&id=4f606e32&scoped=true"
import script from "./CharacterTraits.vue?vue&type=script&lang=js"
export * from "./CharacterTraits.vue?vue&type=script&lang=js"

import "./CharacterTraits.vue?vue&type=style&index=0&id=4f606e32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f606e32"]])

export default __exports__